<ng-container *ngIf="col.type === 'input-text'">
  <p-cellEditor class="form-wrapper">
    <ng-template pTemplate="input">
      <input
        pInputText
        type="text"
        [formControl]="inputTextFc"
        [placeholder]="(col.placeholderFieldId) ?  rowData[col.placeholderFieldId] : ''"
        [pattern]="col.pattern"
        [matTooltip]="getTooltipErrorMessage(inputTextFc)" matTooltipPosition="below"
        matTooltipClass="tooltip-error"
        [(ngModel)]="rowData[col.field]">
    </ng-template>
    <ng-template pTemplate="output">
      <input
        pInputText
        type="text"
        [placeholder]="(col.placeholderFieldId) ?  rowData[col.placeholderFieldId] : ''"
        [matTooltip]="getTooltipErrorMessage(inputTextFc)" matTooltipPosition="below"
        matTooltipClass="tooltip-error"
        [value]="rowData[col.field]">
    </ng-template>
  </p-cellEditor>
</ng-container>


<ng-container *ngIf="col.type === 'input-textarea'">
  <p-cellEditor class="form-wrapper">
    <ng-template pTemplate="input">
      <textarea select-all rows="3" class="textarea-no-resize"
                [(ngModel)]="rowData[col.field]" maxlength="255"></textarea>
    </ng-template>
    <ng-template pTemplate="output">
      <textarea select-all rows="3" class="textarea-no-resize"
                [value]="rowData[col.field]" maxlength="255"></textarea>
    </ng-template>
  </p-cellEditor>
</ng-container>

<ng-container *ngIf="col.type === 'input-dynamicColumn' && col.field === 'variable' && hasAllDynamicValue()">
  <div #tooltip="matTooltip"
       [matTooltip]="getAuditorTooltip(vv)"
       matTooltipPosition="left"
       class="form-wrapper"
       *ngVar="getVariableValue(rowData,col.dynamicValue)?.variableValue as vv">
    <neq-variable-value #valueV #valueField="ngModel" [entity]="rowData"
                        [variableValuePredictionModelValue]="valueField"
                        [variable]="col.dynamicValue"
                        [numberDynamicColumn]="numberDynamicColumn"
                        [predictionModel]="rowData"
                        (update)="updateVariableValue($event)"
                        [ngModel]="vv?.value"
                        [filter]="false"></neq-variable-value>
  </div>
</ng-container>

<ng-container *ngIf="col.type === 'input-dynamicColumn' && col.field === 'model' && hasAllDynamicValue()">
  <div #tooltip="matTooltip" class="form-wrapper"
       [matTooltip]="getAuditorTooltip(vv)"
       matTooltipPosition="left"
       *ngVar="getVariableValue(col.dynamicValue,rowData)?.variableValue as vv">
    <neq-variable-value #valueP #valueField="ngModel"
                        [entity]="rowData"
                        [numberDynamicColumn]="numberDynamicColumn"
                        [variableValueVariableValue]="valueField"
                        [variable]="rowData"
                        [predictionModel]="col.dynamicValue"
                        (update)="updateVariableValue($event)"
                        [ngModel]="vv?.value"></neq-variable-value>
  </div>
</ng-container>

<ng-container *ngIf="col.type === 'input-refCalValue-checkbox'">
  <mat-checkbox (change)="onChangeFromHtml($event, rowData, col.field, col.type)"
                [ngClass]="{'enable-disabled-color-management': enableDisabledColorManagement(rowData, col.field)}"
                class="checkbox-input apply in-table-cell" [class.disabled]="returnFormFromRow(rowData, col.field).disabled"
                [formControl]="returnFormFromRow(rowData, col.field)" color=""></mat-checkbox>
</ng-container>

<ng-container *ngIf="col.type === 'input-refCalValue'">
  <div class="form-wrapper">
    <input
      select-all pInputText type="text"
      *ngIf="!enableDisabledColorManagement(rowData, col.field)"
      [formControl]="returnFormFromRow(rowData, col.field)"
      [placeholder]="returnDefaultValuePlaceholder(rowData, col.field)" (change)="manageReferenceValue(rowData)"
      [matTooltip]="returnTooltipForForm(rowData, col.field)" matTooltipPosition="below"
      matTooltipClass="tooltip-error">
    <input
      select-all pInputText disabled type="text"
      *ngIf="enableDisabledColorManagement(rowData, col.field)"
      class="enable-disabled-color-management">
  </div>

</ng-container>

<ng-container *ngIf="col.type === 'input-refValue-checkbox'">
  <mat-checkbox #cappableInput="ngModel" [checked]="rowData.cappable"
                [ngClass]="{'enable-disabled-color-management': enableDisabledColorManagementForCappableCheckBox(rowData)}"
                class="checkbox-input apply in-table-cell" [class.disabled]="cappableInput.disabled"
                [ngModelOptions]="{updateOn: blur, standalone: true}"
                [(ngModel)]="rowData[col.field]"
                (change)="onChangeFromHtml($event, rowData, col.field, col.type)"
                [disabled]="disableCappable(rowData)"></mat-checkbox>
</ng-container>


<ng-container *ngIf="col.type === 'input-refValue'">
  <div class="form-wrapper">
    <input
      *ngIf="!enableDisabledColorManagementRefValue(rowData)"
      #valInput="ngModel"
      type="text"
      select-all
      pInputText
      [placeholder]="returnDefault(rowData, col.field)"
      [ngModelOptions]="{updateOn: blur, standalone: true}"
      [(ngModel)]="rowData[ col.field + 'Val']"
      (change)="manageReferenceValueBaseRef(rowData, valInput.valid)"
      [pattern]="patternDecimal"
      [matTooltip]="getTooltipErrorMessageFromNumberInputForm(valInput)"
      matTooltipPosition="below"
      matTooltipClass="tooltip-error"
      [disabled]="disableCeilAndFloorInput(rowData)"
      nullValue>
    <input
      *ngIf="enableDisabledColorManagementForFloorCeilInputs(rowData)"
      select-all
      pInputText
      type="text"
      disabled
      class="enable-disabled-color-management">
  </div>

</ng-container>
